export default __webpack_public_path__ + "static/media/71WFmuxYycL.b45ac1f5.webp";